<app-side-menu>
  <app-loading [show]="isLoading" message="Carregando bloqueios..." [overlay]="true"></app-loading>
  
  <div class="container mt-4">
    <div *ngIf="!isCreating">
      <div class="custom-table-container">
        <div class="custom-table-header">
          <h2 class="custom-table-title">{{ tableTitle }}</h2>
          <button class="btn-new-lock" (click)="newLock()">
            <i class="fas fa-plus"></i> Novo Bloqueio
          </button>
        </div>

        <div class="custom-table-search" *ngIf="showSearch">
          <i class="fas fa-search search-icon"></i>
          <input 
            type="text" 
            class="custom-search-input" 
            [placeholder]="searchPlaceholder"
            (input)="onSearch($event)" />
        </div>

        <div class="custom-table">
          <div class="table-row table-header">
            <div class="table-cell">Nome</div>
            <div class="table-cell">Período</div>
            <div class="table-cell">Aprovadores</div>
            <div class="table-cell">Status</div>
            <div class="table-cell">Ações</div>
          </div>

          <div class="table-row" *ngFor="let lock of systemLocks" (click)="onRowClick(lock)">
            <div class="table-cell lock-name-cell">
              <div class="lock-icon">
                <i class="fas fa-lock"></i>
              </div>
              <span class="lock-name">{{ lock.nome || 'Sem título' }}</span>
            </div>
            <div class="table-cell period-cell">
              <span class="period-date">{{ formatDate(lock.dataHoraInicio) }} → {{ formatDate(lock.dataHoraFim) }}</span>
            </div>
            <div class="table-cell approvers-cell">
              <div class="approvers-avatars">
                <div class="approver-item" *ngIf="lock.aprovador1Nome">
                  <div class="mini-avatar" [style.background]="getRandomGradient()">
                    {{ getInitials(lock.aprovador1Nome) }}
                  </div>
                  <div class="approval-indicator" [ngClass]="lock.aprovador1Aprovado ? 'approved' : 'pending'">
                    <i [class]="lock.aprovador1Aprovado ? 'fas fa-check' : 'fas fa-clock'"></i>
                  </div>
                </div>
                <div class="approver-item" *ngIf="lock.aprovador2Nome">
                  <div class="mini-avatar" [style.background]="getRandomGradient()">
                    {{ getInitials(lock.aprovador2Nome) }}
                  </div>
                  <div class="approval-indicator" [ngClass]="lock.aprovador2Aprovado ? 'approved' : 'pending'">
                    <i [class]="lock.aprovador2Aprovado ? 'fas fa-check' : 'fas fa-clock'"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-cell">
              <span class="status-badge" [ngClass]="getStatusClass(lock.status)">
                {{ getStatusLabel(lock.status) }}
              </span>
            </div>
            <div class="table-cell actions-cell">
              <button 
                class="btn-action-approve" 
                *ngIf="lock.status !== 'Executada'"
                (click)="approve(lock); $event.stopPropagation()"
                title="Aprovar">
                <i class="fas fa-check"></i>
              </button>
              <button 
                class="btn-action-reject" 
                *ngIf="lock.status !== 'Executada'"
                (click)="reject(lock); $event.stopPropagation()"
                title="Recusar">
                <i class="fas fa-times"></i>
              </button>
              <button 
                class="btn-action-delete" 
                (click)="delete(lock); $event.stopPropagation()"
                title="Excluir">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="empty-state" *ngIf="!systemLocks || systemLocks.length === 0">
            <i class="fas fa-inbox"></i>
            <p>Nenhum bloqueio encontrado</p>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isCreating" class="custom-table-container">
      <div class="custom-table-header">
        <h2 class="custom-table-title">Novo Bloqueio</h2>
        <div class="header-actions">
          <button class="btn-cancel-new" (click)="cancelCreate()">
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button class="btn-new-lock" [disabled]="!isFormValid" (click)="saveNewLock()">
            <i class="fas fa-save"></i> Salvar
          </button>
        </div>
      </div>

      <div class="form-container">
        <div class="form-row">
          <div class="form-group full-width">
            <label class="form-label">Nome do Bloqueio <span class="required">*</span></label>
            <input class="form-input" type="text" [(ngModel)]="newLockForm.nome" placeholder="Ex: Manutenção, Atualização, etc." />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Data/Hora Início <span class="required">*</span></label>
            <input 
              class="form-input" 
              type="datetime-local" 
              [(ngModel)]="newLockForm.dataHoraInicio" 
              [min]="minDateTime" />
          </div>
          <div class="form-group">
            <label class="form-label">Data/Hora Fim <span class="required">*</span></label>
            <input 
              class="form-input" 
              type="datetime-local" 
              [(ngModel)]="newLockForm.dataHoraFim" 
              [min]="newLockForm.dataHoraInicio || minDateTime" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group full-width">
            <label class="form-label">Motivo <span class="required">*</span></label>
            <textarea class="form-textarea" rows="3" [(ngModel)]="newLockForm.motivo" placeholder="Descreva o motivo do bloqueio"></textarea>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group full-width">
            <div class="approvers-header">
              <label class="form-label">Aprovadores <span class="required">(2 obrigatórios)</span></label>
              <button class="btn-toggle-approvers" (click)="toggleApproversPanel()">
                <i class="fas" [class.fa-chevron-down]="!showApproversTable" [class.fa-chevron-up]="showApproversTable"></i>
                {{ showApproversTable ? 'Ocultar' : 'Selecionar' }} Aprovadores
              </button>
            </div>
            
            <div class="selected-approvers" *ngIf="selectedApprovers.length > 0">
              <div class="approver-chip" *ngFor="let approver of selectedApprovers">
                <div class="chip-avatar" [style.background]="getRandomGradient()">
                  {{ getInitials(approver.name) }}
                </div>
                <span class="chip-name">{{ approver.name }}</span>
                <button class="chip-remove" (click)="removeApprover(approver)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <p class="hint-text" *ngIf="selectedApprovers.length === 0">Nenhum aprovador selecionado</p>
            <p class="hint-text" *ngIf="selectedApprovers.length > 0">{{ selectedApprovers.length }}/2 aprovadores selecionados</p>
          </div>
        </div>

        <div *ngIf="showApproversTable" class="approvers-table">
          <div class="custom-approvers-table">
            <div class="table-row table-header">
              <div class="table-cell">Aprovador</div>
              <div class="table-cell">Status</div>
              <div class="table-cell">Ação</div>
            </div>

            <div class="table-row" *ngFor="let user of users" (click)="onApproverRowClick(user)">
              <div class="table-cell user-cell">
                <div class="user-avatar" [style.background]="getRandomGradient()">
                  {{ getInitials(user.name) }}
                </div>
                <span class="user-name">{{ user.name }}</span>
              </div>
              <div class="table-cell">
                <span class="badge-status" [ngClass]="isApproverSelected(user) ? 'selected' : ''">
                  <i [class]="isApproverSelected(user) ? 'fas fa-check-circle' : 'far fa-circle'"></i>
                  {{ isApproverSelected(user) ? 'Selecionado' : 'Disponível' }}
                </span>
              </div>
              <div class="table-cell actions-cell">
                <button class="btn-select" (click)="onApproverRowClick(user); $event.stopPropagation()">
                  {{ isApproverSelected(user) ? 'Remover' : 'Selecionar' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
